import { Button, Card } from '@mairistem/composants';
import * as React from 'react';
import { createPortal } from 'react-dom';
import { ToastContainer } from 'react-toastify';
import PolitiqueConfidentialiteEnum from '../../enums/PolitiqueConfidentialiteEnum';
import ConfidentialiteModal from './ConfidentialiteModal';
import './PolitiqueConfidentialite.css';

interface PolitiqueConfidentialiteProps {
	onAccept: (state: PolitiqueConfidentialiteEnum) => void;
}

const PolitiqueConfidentialite = ({
	onAccept,
}: PolitiqueConfidentialiteProps) => {
	const [isModalOpen, setIsModalOpen] = React.useState(true);

	const handleChangeState = (state: PolitiqueConfidentialiteEnum) => {
		if (state === PolitiqueConfidentialiteEnum.REFUSED) {
			setIsModalOpen(false);
		}
		onAccept(state);
	};

	const handleReload = () => {
		setIsModalOpen(true);
	};

	return (
		<div className="politique-confidentialite-container">
			{createPortal(<ToastContainer />, document.body)}
			<Card raised className="confidentialite-card">
				<Card.Content>
					<p>Politique de confidentialité refusée.</p>
					<p>Vous pouvez fermer votre navigateur.</p>
					<Button
						onClick={handleReload}
						primary
						className="politique-confidentialite-button"
						fluid
						type="submit"
					>
						J&apos;ai changé d&apos;avis
					</Button>
				</Card.Content>
			</Card>

			{isModalOpen && <ConfidentialiteModal onCheck={handleChangeState} />}
		</div>
	);
};
export default PolitiqueConfidentialite;
